export default __webpack_public_path__ + "static/media/CNo.80-4.845d5261.jpg";